import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../layouts"

class News extends Component {
  constructor(props) {
    super(props)
    this.state = {
      articles: [],
      initialLoad: false,
      loading: true,
      categories: [],
      activeTag: "",
      activeCategory: ""
    }
    this.handleTab = this.handleTab.bind(this)
    this.fetchResults = this.fetchResults.bind(this)
    
  }
  componentDidMount() {
    this.setState({
      loading: true
    });
    // this.fetchResults()
  }
  htmlDecode(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  }
  handleTab() {

  }
  fetchResults() {
    const { data } = this.props
    let url = 'http://' + data.site.siteMetadata.apiUrl + '/wp-json/wp/v2/posts'
    const { order, orderBy, initialLoad} = this.state
    var params = "?"
    

    if (order !== "" || orderBy !== "") {
      params += params.length > 1 ? "&": ""
      params += "orderby=" + orderBy + "&order=" + order
    } else {
      params += params.length > 1 ? "&": ""
      params += "orderby=date&order=desc"
    }
    url += params
    fetch(url)
    .then(response => response.json())
    .then(items => {
      const { search } = this.state

      var query = this.getSearchParam(url)
      if (query === search) {
        let update = {
          products: items,
          loading: false
        }
        if (!initialLoad) {
          update.initialLoad = true
        }  
        this.setState(update)  
      }
      
    })
  }
  render() {
    const data = this.props.data
    const { activeCategory } = this.state


    return (
        <Layout page="news">
          <section className="section news news--social">
            <div className="container">
              <div className="news__social">
                <h1>@VisitFilms on Social</h1>
                <div id="curator-feed-news-layout"><a href="https://curator.io" target="_blank" className="crt-logo crt-tag">Powered by Curator.io</a></div>
              </div>
              
            </div>
          </section> 
          <></>
          <section className="section news">
            <div className="container">
                {/* <h1>News</h1> */}
                <div className="filter--tabs filter--tabs--news">
                    <Link to="/news" >
                        <div className={activeCategory !== "" ? "filter--tab": "filter--tab active"} >All</div>
                    </Link>
                    {data.allWordpressCategory.edges.map(({ node, i }) => (
                        <Link to={"/news/" + node.slug} key={node.slug} >
                            <div className={activeCategory !== node.slug ? "filter--tab": "filter--tab active"} data-tag="" >{node.name}</div>
                        </Link>
                    ))}
                </div>
                <div className="news__feed">
                  {data.allWordpressPost.edges.map(({ node }) => (
                    <div className="news__article" key={node.id}>
                        {node.categories? node.categories.map( (category)  => 
                            <Link to={"/news/" + category.slug} key={category.slug} >
                              <div className="news__category">{category.name}</div>
                            </Link>
                        ): null}
                        {node.featured_media && node.featured_media.localFile? <div className="news__img"><Img src={node.featured_media.localFile.childImageSharp.fluid.src} fluid={node.featured_media.localFile.childImageSharp.fluid} /></div>: null}
                        <Link to={"/" + node.slug}>
                        <h2>{node.title}</h2>
                        </Link>
                        <div dangerouslySetInnerHTML={{ __html: node.content }} />
                        <div className="news__border"></div>
                    </div>
                    ))}
                </div>
            </div>    
          </section>
      </Layout>
    )
  }
}

export default News

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressPost(sort: {order: DESC, fields: date}) {
        edges {
          node {
            title
            content
            slug
            id
            categories {
              name
              slug
            }
            featured_media {
                localFile {
                    childImageSharp {
                        fluid(maxWidth: 1200) {
                            ...GatsbyImageSharpFluid
                          }
                      }
                  }
              }
          }
        }
      }
      allWordpressCategory(filter: {parent_element: {slug: {eq: "news"}}}) {
        edges {
          node {
            id
            name
            slug
          }
        }
      }
      site {
        siteMetadata {
          apiUrl
        }
      }
    }
    
`
